import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import NationalHome from "@/pages/NationalHome";
import Varna2027 from "@/pages/Varna2027";
import Partners from "@/pages/Partners";
import VarnaLanding from "@/pages/VarnaLanding";
import ThankYou from "@/pages/ThankYou";
import Admin from "@/pages/Admin";
import { initPixel, trackPageView } from "@/lib/metaPixel";

function useLenis() {
  useEffect(() => {
    const lenis = new Lenis({
      lerp: 0.09,
      smoothWheel: true,
      wheelMultiplier: 1,
    });
    let rafId;
    function raf(time) {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    }
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);
}

function PixelTracker() {
  const location = useLocation();
  useEffect(() => {
    initPixel();
    trackPageView();
  }, [location.pathname, location.search]);
  return null;
}

function App() {
  useLenis();
  return (
    <div className="App">
      <BrowserRouter>
        <PixelTracker />
        <Routes>
          <Route path="/" element={<NationalHome />} />
          <Route path="/varna-2027" element={<Varna2027 />} />
          <Route path="/partners" element={<Partners />} />
          <Route path="/varna-2026" element={<VarnaLanding />} />
          <Route path="/varna" element={<VarnaLanding />} />
          <Route path="/thank-you" element={<ThankYou />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
